module.exports = __webpack_public_path__ + "static/media/itsLove.2e77a888.jpg";